import type { Tree } from '@festina-life/api'
import type { Optional } from '@festina-life/core'
import { createRequiredContext } from '@festina-life/ui/libs'

import type { MetaModel } from '../types/metaModel'

type MetaModelContextProps = {
  layerTopology: Optional<Tree>
  blockTopology: Tree
  getLayerMetaModel: (layerId: Optional<string>) => MetaModel
  requestLayerMetaModel: (layerId: Optional<string>) => void
  requestedLayerIds: (string | null)[]
}

const [useMetaModelContext, Provider] =
  createRequiredContext<MetaModelContextProps>('MetaModel')

export { Provider, useMetaModelContext }
